<template>
  <div class="device-info-page">
    <!-- <div class="mp-nav">
      <span class="back-btn" @click="goBack">
        <van-icon name="arrow-left" />
      </span>
      <span class="nav-title">设备信息</span>
    </div> -->

    <div class="form-section">
      <!-- 设备信息卡片 -->
      <div class="device-card">
        <div class="device-header">
          <!-- <div class="device-icon">
            <van-icon name="phone-o" size="28" color="#1890ff" />
          </div> -->
          <div class="device-detail">
            <div class="device-name">{{ deviceName }}</div>
            <div class="device-specs">品牌：{{ deviceInfo.brand || '--' }} · 型号：{{ deviceInfo.model || '--' }}</div>
            <div class="device-specs">容量：{{ deviceInfo.ram_size || '--' }} · IMEI：{{ deviceInfo.imei || '--' }}</div>
            <div class="device-specs">指导价：¥{{ deviceInfo.bare_price || '--' }} · 绑定保险：{{ deviceInfo.card_name || '--' }}</div>
          </div>
        </div>

        <div class="time-grid">
          <div class="time-item">
            <div class="time-label">激活时间</div>
            <div class="time-value">{{ deviceInfo.exa_time || addTime }}</div>
            <div class="time-sub">（当前时间）</div>
          </div>
          <div class="time-item green">
            <div class="time-label">状态</div>
            <div class="time-value green-text">{{ deviceInfo.exa_status_text || '待激活' }}</div>
            <div class="time-sub" v-if="deviceInfo.term_time_end">至 {{ deviceInfo.term_time_end }}</div>
          </div>
        </div>

        <div class="validity-badge" v-if="validPeriod !== '--'">
          <van-icon name="passed" color="#52c41a" size="14" />
          生效中：{{ validPeriod }}
        </div>
      </div>

      <!-- 权益介绍 -->
      <div class="rights-card">
        <div class="section-title">权益介绍</div>
        <div
          v-for="item in rightList"
          :key="item.id"
          class="right-item"
          @click="toggleRight(item.id)"
        >
          <div class="right-header">
            <div class="right-name">
              <span class="right-dot" />
              {{ item.name }}
            </div>
            <van-icon
              :name="expandedRights[item.id] ? 'arrow-up' : 'arrow-down'"
              size="28"
              color="#999"
            />
          </div>
          <div class="right-content" v-if="expandedRights[item.id]">
            {{ item.content }}
          </div>
        </div>
      </div>

      <!-- 用户协议 -->
      <div class="agree-wrap">
        <label class="agree-row" @click.stop>
          <input type="checkbox" v-model="agreed" class="agree-checkbox" />
          <span class="agree-text">
            我已阅读并同意
            <span class="agree-link" @click.stop="goAgreement">《用户协议》</span>
            ，确认激活该设备
          </span>
        </label>
        <div class="agree-error" v-if="agreeError">请先勾选同意用户协议</div>
      </div>

      <!-- 底部按钮 -->
      <my-button @click.native="doActivate">立即激活</my-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceInfo',
  data() {
    return {
      orderId: null,
      deviceInfo: {},
      rightList: [
        { id: 1, name: '换机服务', content: '服务有效期内，所投保设备正常使用过程中，发生跌落、挤压、碰撞等意外事故导致设备发生内屏/外屏损坏时（注：设备可显示完整串码）；或因意外事故导致的功能性故障；或因投保设备因质量问题导致的故障。可向服务方提起折抵置换新机申请，换新时超出折抵换新的费用部分，需由消费者自行补齐相应差额。' },
        { id: 2, name: '碎屏服务', content: '服务有效期内，所投保设备在正常使用过程中，发生跌落、挤压、碰撞等意外事故导致设备发生内屏/外屏损坏时，客户可向服务方提出换屏申请。服务方将按本协议的约定条款为消费者提供屏幕更换服务。' },
        { id: 3, name: '电池服务', content: '有效期内，所投保设备经检测电池容量≤90%，或电池发生质量问题，可免费更换电池一次。' },
        { id: 4, name: '延保服务', content: '有效期内，所投保设备发生质量问题可免费维修一次（不包含任何意外造成的损坏，保修范围以设备的官方售后保修政策为准）。' },
        { id: 5, name: '进水服务', content: '有效期内，所投保设备发生意外进水、侵液，主板可读出设备串码时可免费维修一次；若因进水导致设备无法使用但还可完整显示串码的，可按照换机折抵比例进行换机。' },
      ],
      expandedRights: {},
      agreed: false,
      agreeError: false,
      loading: false,
      addTime: '',
    }
  },
  computed: {
    deviceName() {
      const { brand, model } = this.deviceInfo
      if (brand && model) return `${brand} ${model}`
      return brand || model || '--'
    },
    validPeriod() {
      const { term_time_start, term_time_end } = this.deviceInfo
      if (term_time_start && term_time_end) return `${term_time_start} 至 ${term_time_end}`
      return '--'
    },
  },
  mounted() {
    this.orderId = this.$route.query.order_id
    const deviceStr = sessionStorage.getItem('oppoCheckDeviceInfo')
    if (deviceStr) {
      try {
        const data = JSON.parse(deviceStr)
        this.deviceInfo = data
        if (data.right_list && data.right_list.length > 0) {
          this.rightList = data.right_list
        }
      } catch (e) { /* noop */ }
    }
    const now = new Date()
    const pad = n => String(n).padStart(2, '0')
    this.addTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/Oppo/Activate' })
    },
    toggleRight(id) {
      this.$set(this.expandedRights, id, !this.expandedRights[id])
    },
    goAgreement() {
      this.$router.push({ path: '/Oppo/UserAgreement' })
    },
    doActivate() {
      if (!this.agreed) {
        this.agreeError = true
        return
      }
      this.agreeError = false
      if (!this.orderId) {
        this.$toast('订单信息缺失，请重新扫描')
        return
      }
      this.loading = true
      this.$http.oppoActivateDevice({ order_id: this.orderId })
        .then((res) => {
          const deviceInfo = res && res.data
          sessionStorage.setItem('oppoDeviceInfo', JSON.stringify(deviceInfo))
          sessionStorage.removeItem('oppoCheckDeviceInfo')
          this.$router.push({ path: '/Oppo/ActivateSuccess', query: { order_id: this.orderId } })
        })
        .catch((err) => {
          this.$toast((err && err.msg) || '激活失败，请重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.device-info-page {
  min-height: 100vh;
  background: #f5f5f5;

  .mp-nav {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 88px;
    background: #fff;
    padding: 0 32px;
    border-bottom: 1px solid #f0f0f0;

    .back-btn {
      font-size: 36px;
      color: #333;
      margin-right: 20px;
      cursor: pointer;
    }

    .nav-title {
      font-size: 34px;
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .form-section {
    padding: 24px;

    .device-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px;
      margin-bottom: 20px;

      .device-header {
        display: flex;
        gap: 24px;
        margin-bottom: 24px;

        .device-icon {
          width: 96px;
          height: 96px;
          background: #e6f7ff;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .device-detail {
          flex: 1;

          .device-name {
            font-size: 32px;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 8px;
          }

          .device-specs {
            font-size: 22px;
            color: #999;
            line-height: 1.8;
          }
        }
      }

      .time-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        margin-bottom: 20px;

        .time-item {
          background: #f9f9f9;
          border-radius: 12px;
          padding: 20px;
          text-align: center;

          &.green {
            background: #f6ffed;
          }

          .time-label {
            font-size: 22px;
            color: #999;
            margin-bottom: 8px;
          }

          .time-value {
            font-size: 26px;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 4px;
            word-break: break-all;
          }

          .green-text {
            color: #52c41a;
          }

          .time-sub {
            font-size: 20px;
            color: #bbb;
          }
        }
      }

      .validity-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: #f6ffed;
        border: 1px solid #b7eb8f;
        border-radius: 12px;
        padding: 16px 24px;
        font-size: 24px;
        color: #52c41a;
        font-weight: 600;
      }
    }

    .rights-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px;
      margin-bottom: 20px;

      .section-title {
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 16px;
      }

      .right-item {
        border-bottom: 1px solid #f5f5f5;
        padding: 20px 0;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .right-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .right-name {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 28px;
            font-weight: 600;
            color: #1a1a1a;

            .right-dot {
              width: 10px;
              height: 10px;
              background: #1890ff;
              border-radius: 50%;
              flex-shrink: 0;
            }
          }
        }

        .right-content {
          margin-top: 14px;
          font-size: 24px;
          color: #666;
          line-height: 1.8;
          padding-left: 22px;
          background: #f9f9f9;
          border-radius: 10px;
          padding: 16px 20px;
        }
      }
    }

    .agree-wrap {
      background: #fff;
      border-radius: 16px;
      padding: 24px 30px;
      margin-bottom: 20px;

      .agree-row {
        display: flex;
        align-items: flex-start;
        gap: 16px;
        cursor: pointer;

        .agree-checkbox {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          margin-top: 4px;
          accent-color: #1890ff;
          cursor: pointer;
        }

        .agree-text {
          font-size: 26px;
          color: #666;
          line-height: 1.7;

          .agree-link {
            color: #1890ff;
            cursor: pointer;
          }
        }
      }

      .agree-error {
        margin-top: 12px;
        font-size: 24px;
        color: #ff4d4f;
        text-align: center;
      }
    }

  }
}
</style>
